import { CircularProgress } from '@mui/material'
import { createFileRoute } from '@tanstack/react-router'
import { useContext, type JSX } from 'react'
import RbacAccessDeniedPage from '~/components/communication/RbacAccessDeniedPage'
import { SupplyPage } from '~/components/routes/supply/supply-page'
import { AuthContext } from '~/utils/context/auth.context'
import {
  useMigratedRight,
  useMissingPermissions,
  withRoutePermissions,
  type PermissionRequirement,
} from '~/utils/rbac'

/**
 * Écran Supply. `supply.supply.timeline` est une ressource de liaison `selection` : la vue réseau
 * et la vue boutique partagent le tuple, c'est le périmètre d'affectation qui les distingue côté
 * serveur. L'écran n'a donc qu'une permission de lecture.
 */
const SUPPLY_TIMELINE_READ: PermissionRequirement = ['read', 'supply.supply.timeline']

export const Route = createFileRoute('/_authenticated/supply/')({
  staticData: {
    permission: SUPPLY_TIMELINE_READ,
  },
  component: SupplyRoute,
})
withRoutePermissions(Route)

function SupplyRoute(): JSX.Element {
  const { isLoading } = useContext(AuthContext)
  // Tant que `permission-v2` est OFF, le tuple v2 ne discrimine rien : le bit `STOCK_READER` reste
  // la garde effective de l'écran, comme avant la bascule. Sans lui, la page n'affichait qu'une
  // erreur de chargement permanente.
  const canRead = useMigratedRight(SUPPLY_TIMELINE_READ, ['STOCK_READER'])
  const missingPermissions = useMissingPermissions(SUPPLY_TIMELINE_READ)

  if (isLoading) {
    return <CircularProgress />
  }

  if (!canRead) return <RbacAccessDeniedPage missingPermissions={missingPermissions} />
  return <SupplyPage />
}
